import { EditorContent } from '@tiptap/react'
import cn from 'classnames'
import Router from 'next/router'

import { TiptapStickerButton } from '@components/Tiptap/components/TiptapStickerButton'
import { Button } from '@components/Buttons'
import { ThemeEnum } from '@hooks/contexts/ThemeContext/interface'
import { ArrowRight2Icon } from '@components/icons/ArrowRight2Icon'
import { ChatboxIcon } from '@components/icons/ChatboxIcon'
import { Smile2Icon } from '@components/icons/Smile2Icon'
import { SmileDarkIcon } from '@components/icons/SmileDarkIcon'
import { SmileNightIcon } from '@components/icons/SmileNightIcon'
import { TiptapCommentProps } from './interface'

export function TiptapComment({
  theme,
  editor,
  mode,
  isSubmitting,
  isEmpty,
  onCancel,
}: TiptapCommentProps) {
  return (
    <div
      className={cn(
        'relative w-full max-w-[1034px] !dark:bg-blue-4 mobile:max-w-[calc(100%-20px)] mobile:bg-gray-4 mobile:dark:bg-blue-4 mobile:rounded-[20px]',
        { '!max-w-full': mode === 'edit' }
      )}
    >
      {mode === 'create' && (
        <div className='absolute flex flex-row z-[1] top-1/2 left-2 translate-y-[-50%] p-[8px] mobile:hidden'>
          <ChatboxIcon
            className={cn('dark:text-blue-1', {
              '!text-blue-1/50':
                theme === ThemeEnum.DARK &&
                Router.pathname === '/story/[id]/chapter/[chapterId]',
              'text-secondary-1': [ThemeEnum.LIGHT, ThemeEnum.SEPIA].includes(
                theme
              ),
            })}
          />
        </div>
      )}
      <div className='h-max text-secondary-1 dark:text-white'>
        <EditorContent
          editor={editor}
          className={cn(
            'tiptap-comment-input select-text mobile:py-[10px] dark:bg-blue-4',
            {
              'bg-gray-1': ThemeEnum.LIGHT === theme,
              'bg-sepia-3': ThemeEnum.SEPIA === theme,
              '!bg-dark-7 text-dark-10':
                theme === ThemeEnum.DARK &&
                Router.pathname === '/story/[id]/chapter/[chapterId]',
              'rounded-[20px]': mode === 'create',
            }
          )}
        />
      </div>
      {mode === 'create' && (
        <>
          <hr
            className={cn(
              'w-full mobile:bottom-[40px] absolute desktop-tablet:hidden dark:text-secondary-1',
              {
                'text-gray-3 dark:text-purple': [
                  ThemeEnum.LIGHT,
                  ThemeEnum.NIGHT,
                  ThemeEnum.DARK,
                ].includes(theme),
              }
            )}
          />
          <div className='flex flex-row items-center mobile:items-end absolute top-1/2 right-0 desktop-tablet:translate-y-[-50%] py-[5px] mr-[10px] mobile:bottom-0 mobile:top-0'>
            <TiptapStickerButton
              isTransparentBackground
              icon={
                theme === ThemeEnum.NIGHT ? (
                  <SmileNightIcon />
                ) : theme === ThemeEnum.DARK &&
                  Router.pathname === '/story/[id]/chapter/[chapterId]' ? (
                  <SmileDarkIcon />
                ) : (
                  <Smile2Icon className='text-primary' />
                )
              }
              editor={editor}
            />
            <div
              className={cn('w-[1px] h-[25px] mx-[10px]', {
                'bg-gray-12': [ThemeEnum.LIGHT, ThemeEnum.SEPIA].includes(
                  theme
                ),
                'bg-purple': [ThemeEnum.NIGHT, ThemeEnum.DARK].includes(theme),
              })}
            />
            <button type='submit' disabled={isSubmitting || isEmpty}>
              <ArrowRight2Icon
                className={cn('cursor-pointer text-primary', {
                  'text-blue-1': [ThemeEnum.NIGHT, ThemeEnum.DARK].includes(
                    theme
                  ),
                  '!opacity-50':
                    ThemeEnum.DARK === theme &&
                    Router.pathname === '/story/[id]/chapter/[chapterId]',
                })}
                width='24'
                height='24'
              />
            </button>
          </div>
        </>
      )}
      {mode === 'edit' && (
        <div
          className={cn(
            'flex justify-end font-mitr text-sm font-medium border-t px-[15px] py-[10px] dark:bg-blue-4',
            {
              'border-gray-3': [ThemeEnum.LIGHT, ThemeEnum.SEPIA].includes(
                theme
              ),
              'bg-sepia-4': ThemeEnum.SEPIA === theme,
              'bg-gray-4': ThemeEnum.LIGHT === theme,
              'border-secondary-1 dark:border-purple': [
                ThemeEnum.NIGHT,
                ThemeEnum.DARK,
              ].includes(theme),
              '!bg-dark-7':
                theme === ThemeEnum.DARK &&
                Router.pathname === '/story/[id]/chapter/[chapterId]',
            }
          )}
        >
          <Button
            type='button'
            className='dark:text-dark-10 h-[30px]'
            onClick={() => onCancel && onCancel()}
          >
            ยกเลิก
          </Button>
          <Button
            type='submit'
            className={cn('text-white dark:text-white-2  h-[30px]', {
              'bg-primary': [ThemeEnum.LIGHT, ThemeEnum.SEPIA].includes(theme),
              'bg-blue-1': [ThemeEnum.NIGHT, ThemeEnum.DARK].includes(theme),
              '!opacity-70':
                ThemeEnum.DARK === theme &&
                Router.pathname === '/story/[id]/chapter/[chapterId]',
            })}
            disabled={isSubmitting || isEmpty}
          >
            บันทึก
          </Button>
          <TiptapStickerButton
            isTransparentBackground
            icon={
              theme === ThemeEnum.NIGHT ? (
                <SmileNightIcon />
              ) : theme === ThemeEnum.DARK &&
                Router.pathname === '/story/[id]/chapter/[chapterId]' ? (
                <SmileDarkIcon />
              ) : (
                <Smile2Icon className='text-primary' />
              )
            }
            editor={editor}
          />
        </div>
      )}
    </div>
  )
}
